import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./components/LoginPage";
import ChatPage from "./components/ChatPage";
function App() {
 return (
<Router>
<Routes>
<Route path="/" element={<LoginPage />} />
<Route path="/chat" element={<ChatPage />} />
</Routes>
</Router>
 );
}
export default App;